import FeedbackPage from '@app-studio-web/ui/pages/FeedbackPage'
import { getAllAnswers } from '@utils/onboardingStorage'
import { useTranslation } from 'react-i18next'

export default function VibeFeedbackPage() {
  const { t } = useTranslation()
  const allAnswers = getAllAnswers()
  const vibe = allAnswers.vibe?.answer_key

  const isTransform = vibe === 'Ready to transform'
  const isChaotic = vibe === 'A little chaotic'

  const headingKey = isTransform
    ? 'pages.onboarding.v2.vibeFeedback.transform.heading'
    : isChaotic
      ? 'pages.onboarding.v2.vibeFeedback.chaotic.heading'
      : 'pages.onboarding.v2.vibeFeedback.default.heading'
  const textKey = isTransform
    ? 'pages.onboarding.v2.vibeFeedback.transform.text'
    : isChaotic
      ? 'pages.onboarding.v2.vibeFeedback.chaotic.text'
      : 'pages.onboarding.v2.vibeFeedback.default.text'

  return (
    <FeedbackPage
      emoji="🎯"
      heading={t(headingKey)}
      text={t(textKey)}
      onSubmit={() => {}}
    />
  )
}
